export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="leaf-bg relative overflow-hidden">
      <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#4BAF47]/10 blur-3xl" />
      <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-20 md:py-28 relative">
        {eyebrow && <p className="eyebrow mb-4 fade-up">{eyebrow}</p>}
        <h1 className="section-title fade-up delay-1 max-w-3xl">{title}</h1>
        {subtitle && <p className="text-[#878680] text-lg mt-6 max-w-2xl leading-relaxed fade-up delay-2">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
